import $ from 'cash-dom';
import { initDrawer } from './drawer';

/* global global_product */

// Updating Price
$(() => {
  if (typeof global_product === 'undefined') {
    return false;
  }

  const $infoLabel = $('.js-info-label');
  const $price = $('.js-info-price');
  const $priceOriginal = $('.js-info-price-original');
  const $radioPrice = $('.js-radio-price');
  // const $cta = $('.js-pdp-cta');

  $radioPrice.on('change', (event) => {
    const id = event.target.value;
    const { label, price, priceOriginal } = global_product.variants[id] || {};
    // OPTIMIZE, only change DOM if content changes
    $infoLabel.text(label);
    $price.text(price);
    $priceOriginal.text(priceOriginal);
  });

  return true;
});

// // Offer position scrolled
// // Replaced with CSS sticky.
// $(() => {
//   const $offer = $('.js-pdp-offer');

//   if (!$offer.length) {
//     return false;
//   }

//   let isScrolledBeyond;
//   let mainHeight;
//   const $gallery = $('.js-pdp-gallery');
//   const $sticky = $('.js-pdp-stickyUnder');
//   const windowHeight = window.innerHeight;
//   const elDoc = document.documentElement;
//   const mainOffsetHeight = $offer[0].offsetHeight;
//   const mainPixelsFromBottom = windowHeight - mainOffsetHeight;
//   const isTooBig = windowHeight + 30 < mainOffsetHeight;

//   if (window.innerWidth > 850) {
//     $(window).on('scroll', () => {
//       if (isTooBig) {
//         $sticky.css('transform', `translateY(${-window.pageYOffset}px)`);
//       }

//       mainHeight = $gallery[0].offsetHeight;
//       isScrolledBeyond =
//         windowHeight + elDoc.scrollTop > mainHeight + mainPixelsFromBottom;
//       return isScrolledBeyond
//         ? $offer.addClass('isAbsolute')
//         : $offer.removeClass('isAbsolute');
//     });
//   }

//   return true;
// });

const sizeGuideDialog = document.getElementById('size-guide-dialog');
initDrawer(sizeGuideDialog);

if (sizeGuideDialog) {
  const toggleBtns = sizeGuideDialog.querySelectorAll('.size-guide-unit-btn');
  const cells = sizeGuideDialog.querySelectorAll('#size-guide-table td[data-cm]');
  const note = sizeGuideDialog.querySelector('.js-size-guide-note');

  toggleBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const unit = btn.dataset.unit;
      toggleBtns.forEach((b) => {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-pressed', b === btn);
      });
      cells.forEach((td) => { td.textContent = td.dataset[unit]; });
      if (note) {
        note.textContent = unit === 'cm'
          ? 'Measurements are in centimetres. If you\u2019re between sizes, we recommend going up.'
          : 'Measurements are in inches (rounded from centimetres). If you\u2019re between sizes, we recommend going up.';
      }
    });
  });
}

$(() => {
  // $('.js-video-play').on('click', () => {
  //   const video = $('.js-video')[0];
  //   console.log('::clicked', video);
  //   video.play();
  //   this.style.display = 'none';
  // });

  $('.js-video').on('click', (ev) => {
    const video = ev.target;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });
});
